<template>
  <quill-editor
    v-model="text"
    ref="myQuillEditor"
    :options="editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @change="onEditorChange($event)"
  >
  </quill-editor>
</template> 
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  name: "QuillEditor",
  components: { 
    quillEditor 
  },
  props: {
    content: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      text: '',
      editorOption: {},
    };
  },

  created: function () {
      this.text = this.content;
      // console.log('富文本内容：', this.text);
  },
  
  methods: {
    onEditorBlur(event) {
      //失去焦点事件
      console.log('失去焦点事件', event);
    },
    onEditorFocus(event) {
      //获得焦点事件
      console.log('获得焦点事件', event);
    },
    onEditorChange(event) {
      //内容改变事件
      console.log('内容改变事件', event);
      this.$emit("change", event.html);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/widgets/QuillEditor.vue